import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
export default function (_ref) {
  var _ref$defaultSaveAPI = _ref.defaultSaveAPI,
      defaultSaveAPI = _ref$defaultSaveAPI === void 0 ? function () {
    return new Promise();
  } : _ref$defaultSaveAPI,
      _ref$defaultCheckIsUs = _ref.defaultCheckIsUsedAPI,
      defaultCheckIsUsedAPI = _ref$defaultCheckIsUs === void 0 ? function () {
    return new Promise();
  } : _ref$defaultCheckIsUs,
      _ref$isNeedDeleteChec = _ref.isNeedDeleteCheck,
      isNeedDeleteCheck = _ref$isNeedDeleteChec === void 0 ? false : _ref$isNeedDeleteChec,
      _ref$primaryKey = _ref.primaryKey,
      primaryKey = _ref$primaryKey === void 0 ? 'ID' : _ref$primaryKey,
      _ref$defaultGetListMe = _ref.defaultGetListMethod,
      defaultGetListMethod = _ref$defaultGetListMe === void 0 ? 'getLoadData' : _ref$defaultGetListMe,
      _ref$defaultRefs = _ref.defaultRefs,
      defaultRefs = _ref$defaultRefs === void 0 ? 'xTable' : _ref$defaultRefs;
  return {
    data: function data() {
      return {
        mainTable: [],
        loading: false,
        form: {}
      };
    },
    methods: {
      removeClick: function removeClick(row) {
        var _arguments = arguments,
            _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var deleteParams, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  deleteParams = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
                  _context.t0 = row;

                  if (!_context.t0) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 5;
                  return _this.$confirm(_this.$t('publics.tips.makeSureDelete'), _this.$t('publics.tips.tips'), {
                    confirmButtonText: _this.$t('publics.tips.confirm'),
                    cancelButtonText: _this.$t('publics.tips.cancel'),
                    type: 'warning'
                  }).catch(function (_) {
                    /** 取消 */
                  });

                case 5:
                  _context.t0 = _context.sent;

                case 6:
                  if (!_context.t0) {
                    _context.next = 19;
                    break;
                  }

                  if (!isNeedDeleteCheck) {
                    _context.next = 14;
                    break;
                  }

                  _context.next = 10;
                  return defaultCheckIsUsedAPI(deleteParams);

                case 10:
                  res = _context.sent;

                  if (!(res.Result === void 0 || res.Result === true)) {
                    _context.next = 14;
                    break;
                  }

                  if (res.Result === true) {
                    _this.$message({
                      message: _this.$t('publics.tips.isInUsed'),
                      type: 'error'
                    });
                  }

                  return _context.abrupt("return", false);

                case 14:
                  _this.$refs[defaultRefs].remove(row);

                  _context.next = 17;
                  return _this.preserveClick(true, row[primaryKey]);

                case 17:
                  if (!_context.sent) {
                    _context.next = 19;
                    break;
                  }

                  _this.$notify({
                    title: _this.$t('publics.tips.success'),
                    message: _this.$t('publics.tips.deleteSuccess'),
                    type: 'success',
                    duration: 2000
                  });

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      preserveClick: function preserveClick() {
        var _arguments2 = arguments,
            _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var isDelete, isNeedLoadData, postdata, response;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  isDelete = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
                  isNeedLoadData = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : true;
                  postdata = _this2.$refs[defaultRefs].getRecordset();

                  if (!(postdata.insertRecords.length || postdata.removeRecords.length || postdata.updateRecords.length)) {
                    _context2.next = 25;
                    break;
                  }

                  _context2.t0 = !isDelete;

                  if (!_context2.t0) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 8;
                  return new Promise(function (resolve) {
                    _this2.$refs[defaultRefs].validate(function (valid) {
                      if (valid) resolve(false);
                      _this2.form.insertRecords = postdata.insertRecords;
                      _this2.form.updateRecords = postdata.updateRecords;
                      resolve(true);
                    });
                  });

                case 8:
                  _context2.t0 = !_context2.sent;

                case 9:
                  if (!_context2.t0) {
                    _context2.next = 11;
                    break;
                  }

                  return _context2.abrupt("return", false);

                case 11:
                  _this2.form.removeRecords = postdata.removeRecords;
                  _context2.next = 14;
                  return defaultSaveAPI(_this2.form);

                case 14:
                  response = _context2.sent;

                  if (!response.Result) {
                    _context2.next = 22;
                    break;
                  }

                  _this2.form = {};

                  if (isNeedLoadData) {
                    _this2[defaultGetListMethod]();
                  }

                  if (!isDelete) {
                    _this2.$notify({
                      title: _this2.$t('publics.tips.success'),
                      message: _this2.$t('publics.tips.submitSuccess'),
                      type: 'success',
                      duration: 2000
                    });
                  }

                  return _context2.abrupt("return", true);

                case 22:
                  if (isNeedLoadData) _this2[defaultGetListMethod]();

                case 23:
                  _context2.next = 26;
                  break;

                case 25:
                  _this2.$message({
                    showClose: true,
                    message: _this2.$t('publics.tips.noUpdateData'),
                    type: 'warning'
                  });

                case 26:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    }
  };
}